module.exports = __webpack_public_path__ + "static/media/emiliana.5d067496.png";